import React from 'react';
import {
  EVGrid, EVPaper, EVTypography, makeStyles,
} from 'lib/components';
import TextInputField from 'commonComponents/textInputField';
import { useTranslation } from 'lib/translation';
import { updateBlueprintId } from 'features/order/Order.actions';
import { useDispatch, useSelector } from 'lib/redux';

const useStyles = makeStyles((theme) => ({
  productsPaper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '16px 24px 16px 24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[500]}`,
    borderRadius: '0px',
    width: '100%',
  },
  blueprintIdInputLabel: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    textTransform: 'none',
    color: theme.evPalette.charcoal[800],
    marginBottom: '8px',
    '& >.myev-MuiFormLabel-asterisk': {
      color: theme.evPalette.rose[900],
    },
    '&.postalcode': {
      whiteSpace: 'nowrap',
    },
    '&.error': {
      color: theme.evPalette.rose[900],
    },
  },
  inputTextField: {
    height: '44px',
    width: '50%',
    '&.select': {
      paddingTop: 0,
      paddingBottom: 0,
      display: 'flex',
      alignItems: 'center',
    },
    '&.Mui-error > fieldset': { borderColor: `${theme.evPalette.rose[900]} !important` },
  },
  propertyTypeText: {
    fontSize: '14px', lineHeight: '18px', color: '#4D5365', textTransform: 'capitalize',
  },
}));

function PropertySection() {
  const classes = useStyles();
  const { t } = useTranslation();
  const bluePrintId = useSelector(({ placeOrder }) => placeOrder.bluePrintId);
  const bluePrintIdError = useSelector(({ order }) => order.bluePrintIdError);

  const dispatch = useDispatch();

  const handleChange = ({ target: { value } }) => dispatch(updateBlueprintId(value));

  return (
    <EVGrid container style={{ display: 'flex' }}>
      <EVPaper className={classes.productsPaper} elevation={0}>
        <EVGrid item style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <EVTypography className={classes.propertyTypeText}>
            {t('blueprint_order__property_type')}
          </EVTypography>
          <EVGrid style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <EVTypography style={{ fontSize: '16px', lineHeight: '24px' }}>
              {t('Residential')}
            </EVTypography>
            <EVTypography wrap="nowrap" style={{ fontSize: '14px', lineHeight: '18px' }}>
              (
              {t('blueprint_order__residential_only_text')}
              )
            </EVTypography>
          </EVGrid>
        </EVGrid>
        <EVGrid item>
          <EVGrid style={{ flex: '1 1 auto' }}>
            <TextInputField
              handleChange={handleChange}
              inputId="blueprintId"
              inputLabelProps={{ className: classes.blueprintIdInputLabel, required: true }}
              inputValue={bluePrintId}
              labelText={t('blueprint_order__blueprint_id')}
              inputFieldProps={{ InputProps: { classes: { root: classes.inputTextField } } }}
              helperText={bluePrintIdError ? t('common__field_required') : ''}
            />
          </EVGrid>
        </EVGrid>
      </EVPaper>
    </EVGrid>
  );
}

export default PropertySection;
